import styled from "styled-components";
import { fontBold, fontNormal } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";

export const TracksAZWrapper = styled.section`
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("white", "100")};
  height: ${({ isLoading }) => (isLoading ? "100%" : "auto")};
`;

export const Title = styled.h1`
  color: ${buildColor("grey", "D4")};
  font-size: 16px;
  line-height: 125%;
  font-family: ${fontBold};
  padding: 12px 16px;
  box-shadow: inset 0 -1px 0 ${buildColor("grey", "L2")};
`;

export const LetterSpacer = styled.div`
  align-items: center;
  background-color: ${buildColor("white", "100")};
  display: flex;
  flex: 1;
  color: ${buildColor("grey", "800")};
  font-family: ${fontNormal};
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  min-height: 32px;
  padding-left: 12px;
`;
